import Services from "../../Services/Services";
import useAnimationState from "../../../hooks/useAnimationStates";
import styles from "./Category.module.scss";
import dropdownIcon from "../../../assets/icons/accordian-down.svg";
import usePreferencesStore from "../../../store/preferencesStore";

function Category(props) {
  const { preferences } = usePreferencesStore();
  const { setDelay, show, delay } = useAnimationState(true);
  return (
    <div className={styles["category-container"]}>
      <div
        className={styles["category-title"]}
        onClick={() => setDelay(!delay)}
      >
        <div className={styles["dropdown-margin"]}>
          <img
            src={dropdownIcon}
            alt="dropdown-icon"
            style={
              !show
                ? {
                    stroke: "red!important",
                    transform: "rotate(270deg)",
                  }
                : {
                    stroke: "red!important",
                  }
            }
          />
        </div>
        {props.item &&
          (props.item.category_name ? props.item.category_name : "altro")}
        {!show && (
          <span className={styles["services-length"]}>
            {" "}
            {`(${props.item.services.length})`}
          </span>
        )}
      </div>
      {show && (
        <Services
          delay={delay}
          currentStep={props.currentStep}
          data={props.item.services}
          selectedServices={props.selectedServices}
          onServiceSelect={props.onServiceSelect}
          onServiceDeSelect={props.onServiceDeSelect}
        />
      )}
    </div>
  );
}

export default Category;
